(function () {
  'use strict';

  var IN_CART_LABEL = 'Already added to cart';

  function getButtonLabelSpan(button) {
    return button.querySelector('span:not(.sold-out-message):not(.loading-overlay__spinner)');
  }

  function storeOriginalLabel(button) {
    if (button.dataset.originalLabel) return;
    var textSpan = getButtonLabelSpan(button);
    if (textSpan) {
      button.dataset.originalLabel = textSpan.textContent.trim();
    }
  }

  function markButtonInCart(button) {
    storeOriginalLabel(button);
    button.disabled = true;
    button.classList.add('in-cart');
    button.setAttribute('aria-disabled', 'true');

    var textSpan = getButtonLabelSpan(button);
    if (textSpan) {
      textSpan.textContent = IN_CART_LABEL;
    }
  }

  function resetButton(button) {
    if (!button.classList.contains('in-cart')) return;

    button.disabled = false;
    button.classList.remove('in-cart');
    button.removeAttribute('aria-disabled');

    var textSpan = getButtonLabelSpan(button);
    if (textSpan && button.dataset.originalLabel) {
      textSpan.textContent = button.dataset.originalLabel;
    }
  }

  function markCartButtons() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var cartIds = cart.items.map(function (item) {
          return item.variant_id;
        });

        document.querySelectorAll('.quick-add__submit[data-variant-id]').forEach(function (button) {
          var variantId = parseInt(button.dataset.variantId, 10);
          if (!variantId) return;

          if (cartIds.indexOf(variantId) !== -1) {
            markButtonInCart(button);
          } else {
            resetButton(button);
          }
        });
      })
      .catch(function () {});
  }

  window.markCartQuickAddState = markCartButtons;

  document.addEventListener('DOMContentLoaded', markCartButtons);
  document.addEventListener('product-grid:updated', markCartButtons);
  document.addEventListener('cart:updated', markCartButtons);
})();
